var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 239,
    height: 174,
    viewBox: "0 0 239 174",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.277 6L198.049 8.75781L228.549 56.2578L231.234 60.4395L227.625 63.8564L124.125 161.856L120.02 165.744L115.896 161.877L11.3955 63.877L7.91992 60.6172L10.3076 56.4941L37.8076 8.99414L39.541 6H196.277Z",
    fill: "#2ECE6A",
    stroke: "white",
    strokeWidth: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8694 27L89.3625 56.3105H89.9628L105.531 27H123.875L100.429 70L124.4 113H105.719L89.9628 83.6475H89.3625L73.6068 113H55L79.0463 70L55.4502 27H73.8694Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.154 113V27H164.465C170.292 27 175.256 28.2458 179.358 30.7373C183.459 33.2008 186.586 36.6302 188.736 41.0254C190.912 45.3926 192 50.4316 192 56.1426C192 61.8535 190.9 66.8926 188.699 71.2598C186.498 75.627 183.309 79.0283 179.133 81.4639C174.981 83.8994 169.954 85.1172 164.052 85.1172H144.733V70.5459H161.426C164.552 70.5459 167.128 69.944 169.154 68.7402C171.205 67.5085 172.73 65.8148 173.731 63.6592C174.756 61.4756 175.269 58.9701 175.269 56.1426C175.269 53.2871 174.756 50.7956 173.731 48.668C172.73 46.5124 171.205 44.8467 169.154 43.6709C167.103 42.4671 164.502 41.8652 161.351 41.8652H150.397V113H134.154Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73 114L73.5 113L71 112.5L73 114Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXp);
export default __webpack_public_path__ + "static/media/xp.180aa984beb6c9e64d7321adb2bf9268.svg";
export { ForwardRef as ReactComponent };